import { useNavigator } from '@repo/toolkit/use-navigator'
import { SettingIcon } from '@repo/ui/icons'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { useParams } from 'react-router-dom'
import { toast } from 'sonner'

import { getAAKeyword } from '../../../api/aa-keywords/get-aa-keyword'
import { updateAAKeyword } from '../../../api/aa-keywords/update-aa-keyword'
import { ItemNotFound } from '../../../components/elements/item-not-found'
import LoadingScreen from '../../../components/elements/loading/loading-screen'
import UserNavBar from '../../../components/elements/nav-bar'
import AAKeywordForm from '../../../components/pages/aa-keyword/aa-keyword-form'
import { Paths } from '../../../lib/constants/path'
import { updateButtonsConfig } from '../../../lib/utils/buttons-config/validation-buttons-config'
import { showAxiosError } from '../../../lib/utils/functions/misc.functions'
import NotFoundPage from '../../common/not-found'

const AAKeywordUpdatePage = () => {
  const { id } = useParams<{ id: string }>()
  const { navigate, back } = useNavigator()
  const queryClient = useQueryClient()

  if (!id || isNaN(+id)) return <ItemNotFound title="Identifiant de mot-clé invalide" />

  const { mutateAsync } = useMutation({
    mutationFn: updateAAKeyword,
    onError: showAxiosError,
    onSuccess() {
      queryClient.invalidateQueries({ exact: true, queryKey: ['aa-keywords', id] })
      toast.success('Mot-clé modifié avec succès')
    }
  })

  const { data, isLoading } = useQuery({
    queryKey: ['aa-keywords', id],
    queryFn: () => getAAKeyword(+id, ['id', 'label'])
  })

  if (isLoading) return <LoadingScreen />
  if (!data) return <NotFoundPage />

  return (
    <div>
      <UserNavBar title={`Modifier AA ${data.label}`} icon={SettingIcon} />
      <div className={'h-4'} />
      <AAKeywordForm
        defaultValues={{ label: data.label }}
        buttonsConfig={updateButtonsConfig({
          onCancel: () => back(Paths.AA_KEYWORD_LIST_PAGE),
          onUpdate: (values) => mutateAsync({ id: data.id, ...values }),
          onUpdateThenCreate: async (values) => {
            await mutateAsync({ id: data.id, ...values })
            navigate(Paths.AA_KEYWORD_CREATE_PAGE)
          },
          onUpdateThenList: async (values) => {
            await mutateAsync({ id: data.id, ...values })
            navigate(Paths.AA_KEYWORD_LIST_PAGE, { replace: true })
          }
        })}
      />
    </div>
  )
}
export default AAKeywordUpdatePage
